import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Typography } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import useStyles from './language-button-dark-style';



const flagId = require("../../static/images/mfs/flag_id.png");
const flagEn = require("../../static/images/mfs/flag_us.png");

const menus = [
  {
    key: "en",
    name: "English",
    redirect: "/lang/en",
    flag: flagEn,
  },
  {
    key: "id",
    name: "Indonesian",
    redirect: "/lang/id",
    flag: flagId,
  },
];

function LanguageButtonDark(props) {
  const classes = useStyles();
  const {
    className, onSelected,
    textStyle, t, i18n
  } = props;
  const [selected, setSelected] = useState(i18n.language);

  function renderSelected(key) {
    if (key === selected) {
      return classes.selected;
    }
    return null;
  }

  function renderSelectedText(key) {
    if (key === selected) {
      return 'selected';
    }
    return null;
  }

  function buttonOnClick(item) {
    setSelected(item.key);
    if (onSelected) {
      onSelected(item.key);
    }
  }

  function renderMenus() {
    return menus.map((menu, i) => (
      <Grid item container justify="center" alignItems="center" xs key={i.toString()} className={clsx(classes.item, renderSelected(menu.key))}>
        <a
          href={menu.redirect}
          onClick={(e) => {
            if (!menu.redirect) {
              e.preventDefault();
              buttonOnClick(menu);
            }
          }}
        >
          <img src={menu.flag} alt="flag" />
          <Typography variant="subtitle1" className={clsx(classes.btnText, renderSelectedText(menu.key), textStyle)}>{t(menu.name.toLowerCase())}</Typography>
        </a>
      </Grid>
    ));
  }
  return (
    <div className={clsx(classes.root, className)}>
      <Grid container alignItems="stretch" className={classes.gridContainer}>
        {renderMenus()}
      </Grid>
    </div>
  );
}



export default withTranslation(['myfitsociety'])(LanguageButtonDark);
